import { CheckboxField, StringField } from "../../../types/types"
import { RTEFields, RTEProps } from "../types/RTE.types"

export class RTEModel {
  private readonly fields?: RTEFields
  constructor(props: RTEProps) {
    this.fields = props.fields;
  }

  get html(): StringField | undefined {
    return this.fields?.RTE
  }
  get mobileHtml(): StringField | undefined {
    return this.fields?.RTEMobile
  }

  get allowFallbackForMobile(): CheckboxField | undefined {
    return this.fields?.AllowFallbackForMobile
  }
}
